import { Divider } from "../../../ui/Divider/Divider";
import { SystemInformationProps } from "./SystemInformation.type";

export function SystemInformation({
  title,
  description,
}: SystemInformationProps) {
  return (
    <div className="flex flex-col border border-gray-100 rounded-lg p-4">
      <h2 className="text-base font-medium text-left text-gray-900v2">{title}</h2>
      <Divider classes="my-[14px]" />
      <div className="flex flex-col gap-6">
        <div className="flex flex-col gap-2 items-start">
          <span className="text-xs text-gray-550 font-medium uppercase leading-5 tracking-wide">
            Description:
          </span>
          <p className="text-left text-gray-900 tracking-normal">{description}</p>
        </div>
      </div>
    </div>
  );
}
